"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20ContractDeployValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.erc20ContractDeployValidationSchema = (0, yup_1.object)().shape({
    name: yup_rules_1.titleValidationSchema,
    symbol: yup_rules_1.symbolValidationSchema,
    cap: yup_rules_eth_1.bigNumberValidationSchema
        .required("form.validations.valueMissing")
        .min(1, "form.validations.rangeUnderflow")
        .max(BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), "form.validations.rangeOverflow"),
});
//# sourceMappingURL=validation.js.map